import { Avatar, AvatarGroup, AvatarProps, colors, styled } from '@mui/material'
import { GridRenderCellParams, GridTreeNodeWithRender } from '@mui/x-data-grid'
import { ISocialLinkData } from './types'
import { structureVersion } from './configs'
import { getSocialLinkConfig } from './unit.icons'
import { tryParseObject } from '../../utils/helpers'

interface IWrapIconProps extends AvatarProps {
  size?: string | number
  [key: string]: any
}

export const WrapIcon = styled((props: IWrapIconProps) => <Avatar {...props} />)(({ size }) => ({
  width: size || 28,
  height: size || 28
}))

export const renderCellSocials = () => {
  return function func(tableRow: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>) {
    const obj = tryParseObject<ISocialLinkData>(tableRow.value, { StructureVersion: structureVersion, Items: [] })
    const val = Array.isArray(obj?.Items) ? obj.Items : []
    return (
      <AvatarGroup spacing='medium' max={5}>
        {val.map((item, i) => {
          const config = getSocialLinkConfig(item.Type)
          const IconComp = config.Icon
          return (
            <WrapIcon
              key={i.toString()}
              sx={{ bgcolor: config.primaryColor }}
              component='a'
              href={item.Url}
              target='_blank'
              rel='noopener noreferrer'
            >
              <IconComp sx={{ color: config.secondaryColor ?? colors.common.white }} />
            </WrapIcon>
          )
        })}
      </AvatarGroup>
    )
  }
}
